import ComponentPlaceholder from 'components/ComponentPlaceholder';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';

import Hero from './Hero';

interface Props extends SitecoreBlockProps {
	fields?: {
		heading?: Field<string>;
	};
}

export default function HeroBlock({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	if (!fields.heading) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="Hero"
				description="Requires a heading"
			/>
		);
	}

	return (
		<Hero
			className={getEditorMargin(params)}
			heading={fields.heading}
			headingLevel={params?.heading}
		/>
	);
}
HeroBlock.displayName = 'HeroBlock';
